export default __webpack_public_path__ + "static/media/fester-concreto.161ab93b.jpeg";